import React from "react";

function Delete() {
  return (
    <span className="anticon anticon-delete">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        viewBox="0 0 20 22"
      >
        <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
          <g fill="currentColor" transform="translate(-918 -991)">
            <g transform="translate(896 861)">
              <g transform="translate(22 113)">
                <g transform="translate(0 17)">
                  <path d="M13 0a2 2 0 012 2v1h3a2 2 0 012 2v2a2 2 0 01-2 2h-.081L17 20a2 2 0 01-2 2H5c-1.105 0-2-.895-1.997-1.917L2.08 9H2a2 2 0 01-2-2V5a2 2 0 012-2h3V2a2 2 0 012-2h6zm2.913 9H4.086L5 20h10l.003-.083L15.913 9zM18 5H2v2h16V5zm-5-3H7v1h6V2z"></path>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </span>
  );
}

export default Delete;
